import { useCallback, useEffect, useState } from 'react';
import { MapRef } from 'react-map-gl';
import { GeoJSONFeature } from 'mapbox-gl';
import { mapActions } from 'store';
import { openedPopupSelector } from 'store/slices/map/selectors';
import { typesSelector } from 'store/slices/mapV2/mapReducer/settingsSlice/selectors';

import { useAppDispatch, useAppSelector } from './redux';

export const useMarkerPopup = (
  map: MapRef | undefined,
  trigger: string,
  popupKey: string,
  mapTypeKey: string
) => {
  const activePopup = useAppSelector(openedPopupSelector);
  const mapTypes = useAppSelector(typesSelector);
  const [featureData, setFeatureData] = useState<GeoJSONFeature | null>(null);

  const dispatch = useAppDispatch();

  const isPopupOpen = activePopup === popupKey && !!featureData;
  const isActive = mapTypes[mapTypeKey]?.active;

  const onClose = useCallback(() => {
    dispatch(mapActions.setOpenedPopup(null));
    setFeatureData(null);
  }, [dispatch]);

  useEffect(() => {
    if (!map) return;

    const handleClick = (event: any) => {
      if (event.features && event.features.length > 0) {
        const feature = event.features[0];

        event.preventDefault();
        setFeatureData(feature);
        dispatch(mapActions.setOpenedPopup(popupKey));
      }
    };

    map.on('click', trigger, handleClick);
    map.on('touchend', trigger, handleClick);

    return () => {
      map.off('click', trigger, handleClick);
      map.off('touchend', trigger, handleClick);
    };
  }, [map, dispatch, trigger, popupKey]);

  useEffect(() => {
    if (!isActive) {
      onClose();
    }
  }, [isActive, onClose]);

  return { featureData, isPopupOpen, onClose, mapTypes };
};
